import 'vuex';
import { Section, Center } from '@styled/global';
import styled from 'vue-styled-components';
import { fontSize, width } from 'styled-system';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n   ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n   ", "\n\n   margin: 0;\n   display: flex;\n   width: 100%;\n   padding: 0 1.4rem;\n   line-height: normal;\n   -webkit-font-smoothing: antialiased;\n   font-weight: normal;\n   text-align: center;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n   ", "\n\n   margin: 20px 30px;\n   display: flex;\n   width: 100%;\n   line-height: normal;\n   -webkit-font-smoothing: antialiased;\n   justify-content: center;\n   align-items: center;\n   font-weight: 600;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n   width: 100%;\n   margin: 40px auto;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var VideoFrame = styled("div", {})(_templateObject());
var Title = styled("h3", {
  fontSize: {
    default: function _default() {
      return [5, 5, 5, 6];
    },
    type: [Number, String, Object, Array]
  }
})(_templateObject2(), fontSize);
var Message = styled("p", {
  fontSize: {
    default: function _default() {
      return [2, 2, 3, 5];
    },
    type: [Number, String, Object, Array]
  }
})(_templateObject3(), fontSize);
var Video = styled("video", {
  width: {
    default: function _default() {
      return ["320px", "320px", "420px", "800px", "1200px"];
    },
    type: [Number, String, Object, Array]
  }
})(_templateObject4(), width);

var script = {
  props: {
    copy: {
      required: true,
      type: Object
    }
  },
  render: function render() {
    var h = arguments[0];
    return h(Section, {
      "attrs": {
        "mt": "40px",
        "background": "#f0f0f0"
      }
    }, [h(Center, {
      "attrs": {
        "flexDirection": "column"
      }
    }, [h(Title, [this.copy.title]), h(Message, [this.copy.message]), h(VideoFrame, [h(Video, {
      "attrs": {
        "poster": this.copy.poster,
        "controls": true
      }
    }, [h("source", {
      "attrs": {
        "src": this.copy.video.webm,
        "type": "video/webm"
      }
    }), h("source", {
      "attrs": {
        "src": this.copy.video.mp4,
        "type": "video/mp4"
      }
    }), h("p", ["$", this.copy.warning])])])])]);
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
const __vue_script__ = script;

/* template */

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = normalizeComponent(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
